<template>
  <qc-container title="所属商家">
    <page-request ref="table" url="/api/mgr/business/shop/user/list" :table-header="tableHeader" :expend="expend"  :op-width="100">
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  name: "shop-user",
  components: {PageRequest, BButton, QcContainer},
  props:{
    userId:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      tableHeader: [
        {type: "shop", label: "商家",width:300},
        {prop: "money", label: "消费金额",width: 100},
        {prop: "orderCount", label: "订单数量",width: 100},
        {prop: "goodsCount", label: "商品数量",width: 100},
        {prop: "lastTime", label: "最近购买时间"},
        {prop: "createTime", label: "创建时间"},
      ],
      expend:[
        {label: "商家名称",prop: "shopName"},
        {label: "商家ID",prop: "shopCode"},
        {label: "手机号码",prop: "storePhone"},
        {label: "登录时间", start: "lastStartTime", end: "lastEndTime", type: "daterange"},
        {label: "创建时间", start: "startTime", end: "endTime", type: "daterange"}
      ]
    }
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>

</style>
